module.exports = __webpack_public_path__ + "static/ec-exp-393b43d1cc1871269707a73275875011.svg";